export default __webpack_public_path__ + "static/media/03a_fold-13.b8026cfe.mp4";